const ProgressBar = ({ value, maxValue, label, sublabel, color = "#3B82F6" }) => {
  const percentage = (value / maxValue) * 100;

  return (
    <div className="space-y-4">
      <div>
        <div className="text-5xl font-bold text-black mb-1">{value}</div>
        <div className="text-sm text-black font-medium">{sublabel}</div>
      </div>
      
      <div className="space-y-2">
        <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${percentage}%`,
              backgroundColor: color,
            }}
          />
        </div>
        
        <div className="flex items-center justify-between text-xs">
          <div className="flex items-center gap-2">
            <div
              className="w-2 h-2 rounded-full"
              style={{ backgroundColor: color }}
            />
            <span className="text-gray-600">{label}</span>
          </div>
          <span className="text-gray-500">≤{maxValue} days</span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
